import { animate, createTimeline, stagger } from '../../vendor/anime.esm.js';
import { DURATION, EASE, STAGGER, resolveDuration, resolveStagger, BLUR, SUPPORTS_CLIP } from '../motion-tokens.js';

export const teamV1 = (el) => {
    // v1: grid cards — PRIMARIO: avatar reveal circular. SECUNDARIO: cards stagger.
    const cards   = el.querySelectorAll('.team-card, .member-card');
    const avatars = el.querySelectorAll('.team-avatar, .member-avatar, .avatar, img[class*="avatar"]');

    // Estado inicial forzado (antes de anime-init)
    cards.forEach(c => { c.style.opacity = '0'; c.style.transform = 'translateY(25px)'; c.style.filter = 'blur(3px)'; });
    avatars.forEach(a => {
        a.style.opacity = '0';
        if (SUPPORTS_CLIP) a.style.clipPath = 'circle(0% at 50% 50%)';
        else a.style.transform = 'scale(0)';
    });

    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    // Secundario: cards entran con stagger
    if (cards.length) {
        tl.add(cards, {
            opacity:    [0, 1],
            translateY: [25, 0],
            filter:     ['blur(3px)', 'blur(0px)'],
            delay:      stagger(resolveStagger(STAGGER.normal)),
            duration:   resolveDuration(DURATION.slow),
        });
    }

    // Primario: avatares se revelan con clipPath circular perfecto (50% = círculo inscrito exacto)
    if (avatars.length && SUPPORTS_CLIP) {
        tl.add(avatars, {
            clipPath: ['circle(0% at 50% 50%)', 'circle(50% at 50% 50%)'],
            opacity:  [0, 1],
            delay:    stagger(resolveStagger(STAGGER.normal)),
            duration: resolveDuration(DURATION.normal),
            ease:     EASE.snappy,
        }, '-=500');
    } else if (avatars.length) {
        // Fallback sin clipPath
        tl.add(avatars, {
            scale:   [0, 1],
            opacity: [0, 1],
            delay:   stagger(resolveStagger(STAGGER.normal)),
            duration: resolveDuration(DURATION.normal),
            ease:    EASE.bouncy,
        }, '-=500');
    }

    return tl;
};

export const teamV2 = (el) => {
    // v2: horizontal list — PRIMARIO: miembros desde la derecha con stagger elegante (90ms).
    const members = el.querySelectorAll('.team-member, .member-item, .team-row, .team-card');
    if (!members.length) return null;

    return animate(members, {
        opacity:    [0, 1],
        translateX: [80, 0],
        filter:     [BLUR.normal, BLUR.none],
        delay:      stagger(resolveStagger(90)), // elegante: 90ms stagger
        duration:   resolveDuration(DURATION.slow),
        ease:       EASE.snappy,
    });
};

export const teamV3 = (el) => {
    // v3: spotlight+grid — PRIMARIO: spotlight entra con scale dramático.
    // SECUNDARIO: grid stagger después. Overlap temporal de 400ms.
    const spotlight = el.querySelector('.team-spotlight, .team-featured, .member-featured, .team-card:first-child');
    const grid      = [...el.querySelectorAll('.team-card, .member-card')].filter(c => c !== spotlight);
    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    // Primario: spotlight entra translateY desde arriba, escala dramatica
    if (spotlight) {
        tl.add(spotlight, {
            opacity:    [0, 1],
            scale:      [0.9, 1],
            translateY: [-40, 0], // pasa por encima del grid brevemente
            filter:     ['blur(4px)', 'blur(0px)'],
            duration:   resolveDuration(DURATION.slow * 1.2),
            ease:       EASE.refined,
        });
    }

    // Secundario: grid entra con stagger (overlap de 400ms con el spotlight)
    if (grid.length) {
        tl.add(grid, {
            opacity:    [0, 1],
            translateY: [20, 0],
            filter:     ['blur(3px)', 'blur(0px)'],
            delay:      stagger(resolveStagger(STAGGER.fast)),
            duration:   resolveDuration(DURATION.normal),
        }, spotlight ? '-=400' : 0); // overlap deliberado
    }

    return tl;
};
